import AccountCenterSearch from "utils/account_center_search"

const AttendeeSearch = {
  init(newOrEdit) {
    this.newOrEdit = newOrEdit
    AccountCenterSearch.init(this)
    this.bindEvents()
    return this.toggleAttendeeSearchFooter()
  },

  selectPerson(accountCenterId) {
    const input = $(
      `<input type='hidden' name='new_person_account_center_id' value='${accountCenterId}' />`
    )
    $("#new-attendee-form-js").append(input)
    return this.saveAndRefreshForm()
  },

  redirectTo() {
    const modalUrl = $("#new-attendee-form-js").attr("action")
    return modalUrl + "/" + AttendeeSearch.newOrEdit + ".js"
  },

  bindEvents() {
    $("#new-attendee-form-js select").on("change", () => {
      return this.saveAndRefreshForm()
    })
    return $(".remove-attendee-js").on("click", e => {
      $(e.target)
        .closest(".new-attendee-js")
        .remove()
      $("#new-attendee-form-js").toggle($("#new-attendee-form-js tr:visible").length > 1)
      return this.toggleAttendeeSearchFooter()
    })
  },

  saveAndRefreshForm() {
    const url = $("#new-attendee-form-js").attr("action") + `/${AttendeeSearch.newOrEdit}.js`
    return $.get(url, $("#new-attendee-form-js").serialize(), () => {
      this.bindEvents()
      return this.toggleAttendeeSearchFooter()
    })
  },

  toggleAttendeeSearchFooter() {
    if ($(".new-attendee-js:visible").length > 0) {
      return $("#attendee-search-footer-js").show()
    } else {
      return $("#attendee-search-footer-js").hide()
    }
  }
}

export default AttendeeSearch
